import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";

import { actions, useVizDispatch } from "@/shared/state/visualization";
import { TimeBoundsSource } from "@/shared/state/visualization/schema";

import styles from "./SelectTimeBoundsSource.module.css";

interface SelectTimeBoundsSourceProps {
  panelId: string;
  timeBoundsSource: TimeBoundsSource;
}

const TimeBoundsSourceLabels: Record<TimeBoundsSource, string> = {
  [TimeBoundsSource.FilesInPanel]: "Only files in this panel",
  [TimeBoundsSource.FilesInWorkspace]: "All files in workspace",
};

export function SelectTimeBoundsSource({
  panelId,
  timeBoundsSource,
}: SelectTimeBoundsSourceProps) {
  const dispatch = useVizDispatch();

  const onTimeBoundsSourceChange = (event: SelectChangeEvent) => {
    dispatch(
      actions.setPlotPanelConfig(panelId, {
        timeBoundsSource: event.target.value as TimeBoundsSource,
      }),
    );
  };

  return (
    <FormControl className={styles.container} fullWidth>
      <Select
        labelId="time-bounds-source-label"
        id="time-bounds-source-select"
        value={timeBoundsSource}
        onChange={onTimeBoundsSourceChange}
        size="small"
        className={styles.smallFont}
      >
        {Object.values(TimeBoundsSource).map((value) => (
          <MenuItem key={value} value={value} className={styles.smallFont}>
            {TimeBoundsSourceLabels[value]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
